import { useEffect, useState } from 'react';

const LiveCaptions = ({ transcript, enabled, isMobile }) => {
  const [currentCaption, setCurrentCaption] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setCurrentCaption(null);
      return;
    }

    if (!transcript || transcript.length === 0) {
      return;
    }

    // Get the most recent AI-generated caption
    const latestAiCaption = [...transcript]
      .reverse()
      .find(caption => caption.ai_generated === true);
    
    // If no AI caption found, clear current
    if (!latestAiCaption) {
      setCurrentCaption(null);
      return;
    }
    
    // Always update to the latest AI caption
    setCurrentCaption(latestAiCaption);
  }, [transcript, enabled]);

  if (!enabled || !currentCaption) {
    return null;
  }

  const containerStyle = {
    position: 'absolute',
    bottom: isMobile ? '90px' : '100px',
    left: '50%',
    transform: 'translateX(-50%)',
    maxWidth: isMobile ? 'calc(100% - 32px)' : '600px',
    width: isMobile ? 'calc(100% - 32px)' : 'auto',
    minWidth: isMobile ? 'auto' : '300px',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    backdropFilter: 'blur(10px)',
    borderRadius: '12px',
    padding: isMobile ? '12px 16px' : '16px 20px',
    zIndex: 400,
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    animation: 'fadeIn 0.3s ease-in',
  };

  const authorColor = currentCaption.ai_generated 
    ? 'rgba(100, 200, 255, 0.9)' 
    : 'rgba(255, 200, 100, 0.9)';

  return (
    <>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateX(-50%) translateY(10px); }
          to { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
        @keyframes fadeOut {
          from { opacity: 1; }
          to { opacity: 0; }
        }
        
        @media (max-width: 640px) {
          .caption-container {
            bottom: 150px !important;
            padding: 10px 14px !important;
            border-radius: 8px !important;
          }
          .caption-author {
            font-size: 11px !important;
          }
          .caption-message {
            font-size: 14px !important;
          }
        }
      `}</style>
      
      <div className="caption-container" style={containerStyle}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <div
            className="caption-author"
            style={{
              color: authorColor,
              fontWeight: 600,
              fontSize: isMobile ? '11px' : '12px',
              letterSpacing: '0.5px',
              textTransform: 'uppercase',
            }}
          >
            {currentCaption.author}
          </div>
          <div
            className="caption-message"
            style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: isMobile ? '14px' : '16px',
              lineHeight: 1.5,
              fontWeight: 500,
              wordBreak: 'break-word',
            }}
          >
            {currentCaption.message}
          </div>
        </div>
      </div>
    </>
  );
};

export default LiveCaptions;
